export const MIN_SPEED = 100;
export const PERIOD = 'в мес.';

const specification = ({ max_speed, coverage_area, devices_amount }) => `
<table>
    <tr>
        <td>Скорость соединения</td>
        <td>${max_speed} Мбит/с</td>
    </tr>
    <tr>
        <td>Площадь покрытия</td>
        <td>${coverage_area} кв.м</td>
    </tr>
    <tr>
        <td>Одновременно в сети</td>
        <td>${devices_amount} устройств</td>
    </tr>
</table>`;

export const equipment = {
    // САМ-модуль
    102: {
        image: [
            '/static/images/equipment/cam_x60.png',
            '/static/images/equipment/cam_x60.webp',
        ],
        description: `
            <p>Встраивается прямо в телевизор — никаких лишних проводов и дополнительного оборудования.</p>
            <ul>
                <li>Возможность просмотра ТВ в форматах Full-HD</li>
                <li>Тематические пакеты каналов</li>
                <li>Не нужно покупать отдельный пульт. Управляйте cam-модулем, с помощью ТВ-пульта.</li>
            </ul>
        `,
    },
    // Movix
    104: {
        image: [
            '/static/images/equipment/movix_x60.png',
            '/static/images/equipment/movix_x60.webp',
        ],
        description: `
            <p>Приставка знает о ваших интересах и поможет с выбором фильмов и передач. Смотрите кино и сериалы в Full HD качестве и управляйте просмотром.</p>
            <ul>
                <li>Более 50 000 фильмов и сериалов уже на приставке</li>
                <li>Поддержка формата Full-HD</li>
                <li>Пауза, перемотка эфира</li>
            </ul>
        `,
        // gift: `
        //     <p>При покупке приставки Дом.ru Movix вы получаете подарок — пакет каналов «Настоящий мужской» на 3 месяца.</p>
        // `,
    },
    // Комбо-устройство
    300: {
        image: [
            '/static/images/equipment/combo_x60.png',
            '/static/images/equipment/combo_x60.webp',
        ],
    },
    // SIP-адаптер
    301: {
        image: [
            '/static/images/equipment/sip_x60.png',
            '/static/images/equipment/sip_x60.webp',
        ],
    },
    // Smart TV
    20000: {
        name: 'Smart TV',
        alias: 'smartTv',
        price: 0,
        sale_price: 0,
        available_sale: '1',
        period: PERIOD,
        image: [
            '/static/images/equipment/smart_tv_x60.png',
            '/static/images/equipment/smart_tv_x60.webp',
        ],
        description: `
            <p>Если у вас есть Smart-телевизор, установите на него приложение «Дом.ru Movix» и смотрите ТВ-каналы без приставок и лишних проводов.</p>
            <ul>
            </ul>
        `,
    },
    // Мобильное ТВ
    20020: {
        name: 'Мобильное ТВ',
        price: 0,
        sale_price: 0,
        available_sale: '1',
        period: PERIOD,
        image: [
            '/static/images/equipment/mobile_tv_x60.png',
            '/static/images/equipment/mobile_tv_x60.webp',
        ],
        description: '<p>После подключения услуги скачайте приложение «Дом.ru Movix» и смотрите ТВ на смартфоне или планшете.</p>'
    },
    // Домашний ПК
    20021: {
        name: 'ТВ на компьютере',
        price: 0,
        sale_price: 0,
        available_sale: '1',
        period: PERIOD,
        image: [
            '/static/images/equipment/desktop_tv_x60.png',
            '/static/images/equipment/desktop_tv_x60.webp',
        ],
        description: `
            <p>Смотрите телеканалы и фильмы из каталога на сайте movix.ru.</p>
            <ul>
            </ul>
        `,
    },
    // Дом.ru Wi-Fi D1 роутер
    22104: {
        image: [
            '/static/images/equipment/d1_x60.png',
            '/static/images/equipment/d1_x60.webp',
        ],
        coverage_area: 45,
        devices_amount: 6,
        description: max_speed => specification({
            max_speed,
            coverage_area: 45,
            devices_amount: 6,
        }),
    },
    // Дом.ru Wi-Fi D3 роутер
    22105: {
        image: [
            '/static/images/equipment/d3_x60.png',
            '/static/images/equipment/d3_x60.webp',
        ],
        coverage_area: 60,
        devices_amount: 10,
        description: max_speed => specification({
            max_speed,
            coverage_area: 60,
            devices_amount: 10,
        }),
    },
    // Дом.ru Wi-Fi D6 роутер
    22106: {
        image: [
            '/static/images/equipment/d6_x60.png',
            '/static/images/equipment/d6_x60.webp',
        ],
        coverage_area: 80,
        devices_amount: 15,
        description: max_speed => specification({
            max_speed,
            coverage_area: 80,
            devices_amount: 15,
        }),
    },
    // Домашняя сеть Wi-Fi
    22107: {
        image: [
            '/static/images/equipment/home_wifi_x60.png',
            '/static/images/equipment/home_wifi_x60.webp',
        ],
        coverage_area: 0,
        devices_amount: 0,
        description: () => specification({
            max_speed: 300,
            coverage_area: '∞',
            devices_amount: '∞',
        }),
    },
};

// https://kb.ertelecom.ru/pages/viewpage.action?pageId=255034632
export const watchEverywhere = (additionalServicesData) => {

    let priceMobile = 0,
        priceStandard = 1,
        pricePlus = 300;

    if (additionalServicesData) {
        const {
            multiroom_ap_new,
            multiroom_synch_new,
            multiroom_connect_new,
            multiroom_price_mobile,
            multiroom_price_plus,
            multiroom_price_standard,
        } = additionalServicesData;

        priceStandard = (null == multiroom_price_standard)
            ? (multiroom_ap_new + multiroom_synch_new + multiroom_connect_new)
            : multiroom_price_standard;

        priceMobile = (null == multiroom_price_mobile)
            ? priceMobile
            : multiroom_price_mobile;

        pricePlus = (null == multiroom_price_plus)
            ? pricePlus
            : multiroom_price_plus;
    }

    return ([
        {
            id: '0',
            name: 'Mobile',
            price: priceMobile,
            period: PERIOD,
            description: `
            <p>Для тех, у кого только 1 телевизор</p>
            <ul>
                <li>1 ТВ + 4 мобильных устройства</li>
            </ul>
        `,
        },
        {
            id: '101734',
            name: 'Standard',
            price: priceStandard,
            period: PERIOD,
            description: `
            <p>Для тех, у кого 2 и более телевизоров</p>
            <ul>
                <li>5 любых устройств</li>
                <li>Скоростной бонус до 100 Мбит/с</li>
            </ul>
        `,
        },
        {
            id: '101735',
            name: 'Plus',
            price: pricePlus,
            period: PERIOD,
            description: `
            <p>Для тех, у кого много устройств</p>
            <ul>
                <li>10 любых устройств</li>
                <li>Скоростной бонус до 100 Мбит/с</li>
            </ul>
        `,
        },
    ]);
};

export const homePhone = {
    // Безлимитный!
    100047: {
        description: `
            <p>Стоимость местного соединения — 0,20 руб. в мин.</p>
        `,
    },
    // Любимый регион
    1191: {
        description: `
            <p>Звоните в любимый регион со скидкой</p>
        `,
    },
    // Любимая страна
    1192: {
        description: `
            <p>Звоните в выбранные страны со скидкой</p>
        `,
    },
    // Моя Москва
    1785: {
        description: `
            <p>Звонки в Москву со значительной скидкой</p>
        `,
    },
    // 60 минут по России
    1875: {
        description: `
            <p>На городские номера</p>
        `,
    },
};

export const phoneData = phoneTariff => ({
        id: phoneTariff.tariff_id,
        name: phoneTariff.tariff_name,
        price: phoneTariff.price,
        additionalServices: [
            {
                id: 1191,
                name: 'Любимый регион',
                price: phoneTariff.price_favorite_region,
            },
            {
                id: 1192,
                name: 'Любимая страна',
                price: phoneTariff.price_favorite_country,
            },
            {
                id: 1785,
                name: 'Моя Москва',
                price: phoneTariff.price_my_moscow,
            },
            {
                id: 1875,
                name: '60 минут по России',
                price: phoneTariff.price_60_min,
            },
        ],
    });

export const additionalServices = (additionalServicesData) => ({
    prim: {
        name: 'Родительский контроль',
        price: 99,
        period: PERIOD,
        description: `
            <p>Защита детей в сети.</p>
            <ul>
                <li>Будьте в курсе, где находится ваш ребенок</li>
                <li>Регулируйте использование программ</li>
                <li>Ограничивайте доступ к неподходящим сайтам и информации</li>
            </ul>
        `,
    },
    telearchive: {
        name: 'Управляй просмотром',
        price: additionalServicesData ? additionalServicesData.telearchive : 70,
        period: PERIOD,
        hint: 'Смотрите фильмы, ток-шоу в течение 7 дней после их выхода в эфир.',
        description: `
            <p>Управляйте просмотром и не пропускайте интересные фильмы и передачи.</p>
            <ul>
                <li>Перематывайте рекламу</li>
                <li>Ставьте передачи на паузу</li>
                <li>Смотрите фильмы и телешоу до 7 дней после их выхода в эфир</li>
            </ul>
        `,
    },
});

export const getRequiredEquipmentAndVasTotalPrice = (tariff) => {
    const requiredEquipments = tariff?.additionalProducts
        ?.filter(item => item.required && item.leasing_duration);
    const priceIncludedVas = Number(tariff.priceIncludedVas || tariff.price_included_vas || 0);

    if (!requiredEquipments || requiredEquipments.length === 0) {
        return priceIncludedVas;
    }

    let totalPrice = requiredEquipments
        .reduce((acc, item) => acc + item.price, 0) ?? 0;

    if (tariff.type === 'bundles' || tariff.sale_package_id) {
        totalPrice += priceIncludedVas;
    }

    return totalPrice;
};
